import axios from 'axios';

// export const URL = "http://localhost:8000/"
// export const THIS_URL = "http://localhost:3000/"
// export const STORAGE_FILES_URL = "http://localhost:8000/"

// export const URL = "https://onteste.enterscience.com.br/"

// export const THIS_URL = "https://admin.enterscience.com.br/"

// export const URL = "https://onteste.itec.edu.br/"
// export const THIS_URL = "https://admin.itec.edu.br/"

export const URL = "https://api-admin.ontest.com.br/";
export const THIS_URL = "https://admin.ontest.com.br/";
export const STORAGE_FILES_URL = "https://api-admin.ontest.com.br/";

export const API_URL = URL + "api/";
// export const STORAGE_URL = URL + "storage/";
export const STORAGE_URL = '';
export const SOCKET_API_ENCRYPTION_KEY = '';
export const API_ENCRYPTION_KEY = 'sk_live_kokNYsEWUm2LI4x0jFKr7cT7ll6D3ErD';
let encryptedApiResponsesInstalled = false;

export function getSocketApiEncryptionKey() {
    return SOCKET_API_ENCRYPTION_KEY || process.env.REACT_APP_SOCKET_API_ENCRYPTION_KEY || '';
}

export function getApiEncryptionKey() {
    return API_ENCRYPTION_KEY || process.env.REACT_APP_API_ENCRYPTION_KEY || '';
}

function canUseCrypto() {
    return typeof window !== 'undefined'
        && window.crypto
        && window.crypto.subtle
        && typeof TextEncoder !== 'undefined'
        && typeof TextDecoder !== 'undefined';
}

function base64ToBytes(value) {
    const binary = window.atob(value);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return bytes;
}

async function buildCryptoKey() {
    const keyBytes = new TextEncoder().encode(getApiEncryptionKey());
    const digest = await window.crypto.subtle.digest('SHA-256', keyBytes);
    return window.crypto.subtle.importKey('raw', digest, { name: 'AES-CBC' }, false, ['decrypt']);
}

export async function decryptApiResponseValue(value) {
    const key = getApiEncryptionKey();
    if (!key || !canUseCrypto() || value == null || value.__encrypted !== true || !value.payload || !value.iv) {
        return value;
    }

    const cryptoKey = await buildCryptoKey();
    const decrypted = await window.crypto.subtle.decrypt({ name: 'AES-CBC', iv: base64ToBytes(value.iv) }, cryptoKey, base64ToBytes(value.payload));
    return JSON.parse(new TextDecoder().decode(decrypted));
}

export function installEncryptedApiResponses() {
    if (encryptedApiResponsesInstalled || typeof window === 'undefined' || !window.fetch) {
        return;
    }

    const originalFetch = window.fetch.bind(window);
    axios.interceptors.request.use((config) => {
        const key = getApiEncryptionKey();
        const url = config && config.url ? config.url : '';

        if (key && String(url).indexOf('/api/') !== -1) {
            config.headers = config.headers || {};
            config.headers['X-Accept-Encrypted-Response'] = 'true';
        }

        return config;
    });

    axios.interceptors.response.use(async (response) => {
        if (response && response.headers && response.headers['x-encrypted-response'] === 'true') {
            response.data = await decryptApiResponseValue(response.data);
        }

        return response;
    });

    window.fetch = async function (input, init = {}) {
        const key = getApiEncryptionKey();
        const headers = new Headers(init.headers || {});
        const url = typeof input === 'string' ? input : input.url;

        if (key && String(url).indexOf('/api/') !== -1) {
            headers.set('X-Accept-Encrypted-Response', 'true');
            init = { ...init, headers };
        }

        const response = await originalFetch(input, init);

        if (!key || response.headers.get('X-Encrypted-Response') !== 'true') {
            return response;
        }

        try {
            const envelope = await response.clone().json();
            const decrypted = await decryptApiResponseValue(envelope);
            const responseHeaders = new Headers(response.headers);
            responseHeaders.delete('X-Encrypted-Response');

            return new Response(JSON.stringify(decrypted), {
                status: response.status,
                statusText: response.statusText,
                headers: responseHeaders
            });
        }
        catch (e) {
            console.log('API response decrypt catch', e && e.stack ? e.stack : e);
            return response;
        }
    };

    encryptedApiResponsesInstalled = true;
}
